export default "__VITE_ASSET__BaLar5gc__"